import { useEffect, useState } from "react";
import { RoleNames } from "../roleNames";
import { FileAccessibilityMapping } from "../../../common/constants";

const _props = {
    inputForm: {},
    field: {}, 
    fieldState:{},
    controlConfig: {},
}
function Comp_FileAccessibility(props = _props) {
    
    const { formState: { errors }, getValues: inputForm_getValues, setValue: setInputFormValue } = props.inputForm;
    const parent_field = props.controlConfig?.mappedParentField;
    const inputFormValues = inputForm_getValues() || {} ;
    const parent_field_value = inputFormValues[parent_field];
    const isFileAccessibility = (parent_field_value || '').toLowerCase() === FileAccessibilityMapping.group
    props.controlConfig.rules.required.value = isFileAccessibility ? true : false;
    
    

    return isFileAccessibility ? <div >
     <RoleNames
          className={props.classNames({ "p-invalid": props.fieldState?.invalid })}
          field={props.field}
          fieldState={props.fieldState}
          controlConfig={props.controlConfig}
        />
    </div>
    :  null
}

export const FileAccessibility = Comp_FileAccessibility;